// extracted by mini-css-extract-plugin
export default {"marker":"MarcadorDeZonaComponent_marker__uEefq","pin1":"MarcadorDeZonaComponent_pin1__oIovt","pin2":"MarcadorDeZonaComponent_pin2__yLrKD"};